module.exports = {
  "country": "NO",
  "artist": "Subwoolfer",
  "song": "Give that Wolf a Banana",
  "year": "2022",
  "place": "10",
  "spotify": "50Cf2eYv8zT3v2HAkwhIiL"
};